import { useAuth0 } from "@auth0/auth0-react";
import { useCallback, useEffect, useState } from "react";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { GetUsernamesRequest, User } from "../proto/api_pb";
import useGetValidAccessToken from "./useGetValidAccessToken";

type ReturnType = {
  allUsers: User[];
  featuredUsers: User[];
  regularUsers: User[];
  isAllUsersLoading: boolean;
  getAllUsers: () => Promise<void>;
};
export const useGetAllUsers = (): ReturnType => {
  const { isAuthenticated } = useAuth0();
  const { getValidAccessToken } = useGetValidAccessToken();
  const [allUsers, setAllUsers] = useState<Array<User>>([]);
  const [regularUsers, setRegularUsers] = useState<Array<User>>([]);
  const [featuredUsers, setFeaturedUsers] = useState<Array<User>>([]);

  const [isLoading, setIsLoading] = useState(false);

  const getAllUsers = useCallback(async () => {
    try {
      if (isAuthenticated) {
        const accessToken = await getValidAccessToken();
        if (accessToken) {
          setIsLoading(true);
          const ommuseClient: OmmuseClient = new OmmuseClient(
            process.env.REACT_APP_API_URL!
          );
          const metadata = {
            Authorization: `${accessToken}`,
            "Access-Control-Allow-Origin": "*",
          };

          const request = new GetUsernamesRequest();

          ommuseClient.getUsernames(request, metadata, (err, response) => {
            if (err) {
              console.log("Get Username List Error");
              console.log(err.message);
              setIsLoading(false);
            } else {
              const featuredUserNameList = response.getFeaturedUsersList();
              const regularUserNameList = response.getRegularUsersList();
              const userNameList =
                featuredUserNameList.concat(regularUserNameList);
              setAllUsers(userNameList);
              setFeaturedUsers(featuredUserNameList);
              setRegularUsers(regularUserNameList);
              setIsLoading(false);
            }
          });
        }
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }, [getValidAccessToken, isAuthenticated]);

  useEffect(() => {
    getAllUsers();
  }, [getAllUsers]);

  return {
    allUsers,
    featuredUsers,
    regularUsers,
    isAllUsersLoading: isLoading,
    getAllUsers,
  };
};
